import React from 'react';
import { HrefDiv } from './Components.styles';

const IntroSection = ({ id, name, description }) => {
	return (
		<>
			<HrefDiv id={id} />
			<h1>{name}</h1>
			<p>{description}</p>
		</>
	);
};

export default IntroSection;
